/* eslint-disable */
import React from "react";
import "../css/FaqPage.css";

export const faqOverview = [
  {
    title: "Getting Started",
    content: (
      <div className="faq-overview-item-content">
        <div className="faq-overview-item-text">
          <p>Welcome</p>
          <p>
            For over sixteen years, the Advanced Intelligence Services
            Corporation has conducted extensive metabolic, biological, and
            artificial physics infrastructure research and developed
            sophisticated field operation training and support programs to
            improve the U.S. Military’s definition of core asset defense
            management, while streamlining the escalating costs of traditional
            and advanced defense goals, objectives, and tasks, ensuring
            consistent delivery of national defense excellence today and into
            America’s future.
          </p>
          <p>
            Whether your defense concerns are present or potential, A.I.S. has
            the expertise to produce comprehensive, easy-to-understand physics
            infrastructure definition products military organization leaders
            require to identify multi-circa solution management opportunities.
          </p>
          <p>
            What is multi-circa solution management? Beginning with the end in
            mind, A.I.S. coordinates physics expression data, event contingency
            analyses, and intelligent live-time field support modules to educate
            DoD management personnel and increase defense solution durability
            before, during, or after specific events occur.
          </p>
          <p>
            A.I.S. is also a premier developer of next-generation field
            operation training and support programs structured to fortify and
            maximize pivotal outcomes of the U.S. Defense Department, ensuring
            durable success in the most critical contexts of biodefense during
            the twenty-first century, and beyond.
          </p>
          <p>
            Start your A.I.S. partnership by requesting a free telephone
            consultation to discuss proprietary physics infrastructure research
            with annual, quarterly, and monthly report options, or order custom
            physics products and services via our web site. Order confirmation,
            customization, and payment are always processed offline. To get
            started, explore the A.I.S. Product Catalog or call us toll-free at:
            1-800-427- 9479.
          </p>
          <p style={{textDecoration: 'underline'}}>Learn More</p>
          <a href="/products">
            <p>A.I.S. Product & Service Catalog</p>
          </a>
          <a href="/investor">
            <p>Investor Relations</p>
          </a>
          <a href="/support">
            <p>Contact A.I.S.</p>
          </a>
        </div>
      </div>
    ),
  },
  {
    title: "Physics Infrastructure Research, Analysis & Development",
    content: (
      <div className="faq-overview-item-content">
        <div className="faq-overview-item-text">
          <p>
            The Advanced Intelligence Services Corporation is America’s global
            leader in the definition, research and design of defense-grade
            metabolic, biological, and artificial physics information
            technologies. As a defense corporation, our core asset defense
            management approach is based on the live-time analysis of key facts,
            field data, and resource compatibilities between historic and recent
            discoveries about innovations in biophysics, and how those concepts
            relate to the biodefense industry, in and beyond 2022.
          </p>
          <p>
            Today more than ever, America’s toughest challenges require experts
            in, and beyond the biotechnology industry. Our company is seeking
            partners in the development of biological human interface device
            products designed to rapidly communicate A.I.S. reports and
            important field data between service personnel and their superiors.
          </p>
          <p>
            The Advanced Intelligence Services Corporation is devoted to
            accurate, ethical physics infrastructure research that defense
            specialists will appreciate throughout the development and
            deployment of safe, dependable biotechnologies engineered to drive
            national defense into the twenty-second century.
          </p>
          <p>
            To learn more, call toll-free: 1-800-427-9479 or e-mail:
            services@aisincorporated.com.
          </p>
          <a href="/research">
            <p>Read More</p>
          </a>
        </div>
      </div>
    ),
  },
  {
    title: "Training Modules, Workshops & Seminars",
    content: (
      <div className="faq-overview-item-content">
        <div className="faq-overview-item-text">
          <p>
            Maintaining the U.S. Military’s prowess against domestic and foreign
            state-sponsored metabolic physics warfare conduct is the premier
            biodefense challenge of the twenty-first century.
          </p>
          <p>
            Precision is critical. If your military personnel effort standard
            field operations and recognize sudden fatigue, irrational confusion,
            or other acute symptoms of physical or psychological disfunction,
            discover how the Advanced Intelligence Services Corporation helps
            military personnel to achieve specific and durable results in core
            asset mission environments, where metabolic physics warfare is
            prevalent.
          </p>
          <p>
            The proficiency of the goals, objectives, and tasks of the United
            States Department of Defense is at stake. When circa-contextual
            biodefense solutions render unimpressive results, or metabolic
            physics warfare impacts political or military affairs, count on
            A.I.S. to manage adverse biophysics conditions with a multi-circa
            approach to defending the core asset level of pre-expression
            metabolic physics infrastructure. No further details about this
            A.I.S. service are available on the internet.
          </p>
          <p>
            To schedule a live consultation and find out about A.I.S. field
            support availability, please call: 1-800-427- 9479.
          </p>
        </div>
      </div>
    ),
  },
  {
    title: "Field Operation Support Programs",
    content: (
      <div className="faq-overview-item-content">
        <div className="faq-overview-item-text">
          <p>
            A.I.S. personnel spent years studying historic and modern trends in
            the use of biological warfare as well as the progression of related
            effects on physical and psychological human health, with an emphasis
            on the impact to metabolic (human energy expression) physical
            infrastructure. Extended research objectives also considered the
            social, economic, and diplomatic impacts to the American societal
            macromodel between 1998 and 2021.
          </p>
          <p>
            Metabolic physics infrastructure research was conducted primarily
            from the epicenter of the North American land mass (Chicagoland),
            however also included observations conducted in other U.S. states,
            some in government facilities hosting a large population of people
            (over 500 on-site residents).
          </p>
          <p>
            Jimmie David Ray, Junior is the primary Founder, Chief Executive
            Officer, and Program Administrator of the Advanced Intelligence
            Services Corporation. Ray is a 4.00 core-G.P.A. declared multi-major
            with the experience-based vision, ultimate perseverance, and devoted
            leadership qualities senior military specialists deem necessary to
            contribute external metabolic physics data complimenting field
            operations in tandem with the expertise of the United States
            Military’s most elite personnel. At this time, virtual training
            modules, workshops, and seminars are available for immediate
            live-time integration in new and ongoing field operations. No
            further details about this A.I.S. service are available on the
            internet.
          </p>
          <p>
            To schedule a live consultation and outline your immediate training
            or continuing education needs, please call: 1-800-427-9479.
          </p>
        </div>
      </div>
    ),
  },
  {
    title: "National Community Development Initiatives",
    content: (
      <div className="faq-overview-item-content">
        <div className="faq-overview-item-text">
          <p>
            Across America, thousands of communities benefit from the strong
            protection of the United States Defense Department. At the Advanced
            Intelligence Services Corporation, we are devoted to funding
            durable, steady community development throughout America, while
            encouraging citizens nationwide to reach for their physical dreams
            throughout their experience of life, liberty, and the pursuit of
            happiness.
          </p>
          <p>
            As surplus funds are made available, A.I.S. donates goods,
            resources, and cash to communities throughout the United States.
            Storm relief, school supplies, reforestation, and criminal justice
            are among the many causes A.I.S. supports on an annual basis. For
            more information, or to register your cause, please call toll-free:
            1-800-427-9479, or e-mail: communities@aisincorporated.com. Read
            More (read more links to our Ethics page).
          </p>
        </div>
      </div>
    ),
  },
];

export const faqQuestions = [
  {
    question: "How do I schedule an introductory consultation?",
    answer: <><p>To schedule initial consultation, please A.I.S. call toll-free: 1-800-427-9479, or e-mail:
    services@aisincorporated.com.</p><a href="/support">- Read More</a></>,
  },
  {
    question:
      "What state is the Advanced Intelligence Services Corporation incorporated in?",
    answer:
    <><p>Advanced Intelligence Services, Incorporated is registered in the State of Delaware.</p></>
      ,
  },
  {
    question:
      "In what year was the Advanced Intelligence Services Corporation founded?",
    answer: 
    <><p>The Advanced Intelligence Services Corporation was established in January of 2006, and
    incorporated on March 03, 2010.</p></>,
  },
  {
    question: "How do I invest in A.I.S.?",
    answer: 
    <><p>To get started, select an area of interest, and contact Jim D. Ray for investor support toll-
    free, at: 1-800-427-9479, or e-mail: invest@aisincorporated.com.<a href="/investor">- Read More</a></p></>,
  },
  {
    question:
      "How do I responsibly expand my military organization’s multi-circa biodefense net?",
    answer: <><p>Non-linear, metabolic physics-based information management technologies give military
    organizations the ability to conduct secure live-time briefings between intervals of independent
    physical space, representing the next frontier of information-education as the U.S. Military shifts
    defense planning from solution estimation by experience to fact-answer delivery based on the
    progression of humanity by work, response and recovery occurring in, and well beyond the
    twenty-first century.</p><a href="/research">- Read More</a>
    </>,
  },
  {
    question:
      "Does A.I.S. engineer metabolic physics information technologies?",
    answer: <><p>A.I.S. is focused on the production of information products and services that educate military
    personnel to provide durability and support in ongoing operations introducing metabolic,
    biological, and artificial physics applications throughout the Department of Defense.</p><a href="/innovations">- Read More</a></>,
  },
  {
    question: "What is meta?",
    answer:<><p>“Meta” has become a popular cultural catchword, recently rooted in the public world as a
    digital virtual environment called the Metaverse. Meta is actually short for metabolic, or the
    term describing the physical expression process of life by and which all methods of the biological
    Universe are dependent on, including, but not limited to, precelluar structure, dynamic cellular
    regeneration, reproduction, aging, as well as the physical protocols of common human physical,
    and mental health. Metabolic physics is the field of study pertaining to the sourceology and
    infrastructure of biological energy algorithms responsible for installing the unique properties of
    life in physical D.N.A.</p><a href="/biophysics">- Read More</a></>,
  },
  {
    question: "Where is A.I.S. going in the future?",
    answer: <><p>Over the next twenty years, A.I.S. will seek to achieve several founding metabolic physics
    information technology compatible with the twenty-first century and sure to contribute success
    and favor in a number of industries, where A.I.S. will be the first to address core asset security –
    biodefense down to the level of expressing physics – in education, commerce, healthcare, and
    entertainment.</p><a href="/innovations">- Read More</a></>,
  },
  {
    question: "How does A.I.S. contribute back to local communities?",
    answer: <><p>A.I.S. donates physical resources and financial contributions to local communities as military
    funding and corporate personnel are accessible for public philanthropy initiatives.</p></>,
  },
  {
    question:
      "What is the standard turnaround time for A.I.S. information products?",
    answer: <><p>A.I.S. custom information products are individually prepared upon placement of order
    (payment due at the time of order) and require approximately 30-60 days for fulfillment. Access
    to our rolling discovery and innovation research reports is available in annual, quarterly, or
    monthly subscription products.</p><a href="/products">- Read More</a></>,
  },
  {
    question: "How do I learn more?",
    answer: <><p>If you should have questions, opinions or feedback about A.I.S., please call Jim D. Ray,
    Founder and C.E.O. of the Advanced Intelligence Services Corporation, direct at: 1-800-427-
    9479, or e-mail your thoughts to: services@aisincorprorated.com.</p></>,
  },
  {
    question:
      "Can I share A.I.S. briefings and reports with other military or government organizations?",
    answer: <><p>Because information products are customized to the state of specific conditions, A.I.S. does
    not advise military organization managers to share information products with other military,
    federal, or municipal organizations.</p></>,
  },
  {
    question: "Is it common to interact with A.I.S. personnel in public?",
    answer: <><p>Privacy and safety are the keys to precision in the ongoing effort to coordinate lasting
    national biodefense initiatives. According to recent F.B.I. reports, foreign corporate espionage
    has reached an all-time high, particularly impacting the biotechnology industry, affecting most
    public safety protocols across our organization. Our personnel are trained, highly skilled
    professionals with the responsibility of ensuring public safety while at work. Similar to other
    defense corporation brands, A.I.S. corporate officers are badged defense contractors, and
    considered experts in a field of specialized defense knowledge. With respect for the demanding
    nature of today’s national security goals, objectives, and tasks reaching to the local level, if you
    are not competent in the protocols of domestic core asset analysis and biodefense solution
    implementation in 2022, including the nature of field research conduct, please refrain from
    approaching or following A.I.S. personnel in public.</p></>,
  },
];
